import { ChevronDownIcon } from '@chakra-ui/icons';
import { Box, Button, Heading, Link, Menu, MenuButton, MenuItem, MenuList, Text, useMediaQuery } from '@chakra-ui/react';
import { theme } from '../../../assets/style/theme';

type Props = {
  data: any[];
  term: string;
  slug: string;
};

function ParticipationSubMenu({ data, term, slug }: Props) {
  
  const isActive = (itemSlug: string) => {
    return itemSlug === `${term}${slug}`;
  }

  const href = (itemSlug: string) => {		
    return `/participation/${term}/${itemSlug.slice(-2)}`;
  }
  
  const labelFilter = (label:string) => {		
    if (label.includes('<b>')) {
      return label.split('<b>')[1].split('</b>')[0];
    }
    if (label.includes('&amp;')) {
      return label.replace('&amp;', '&');
    }
    return label;
  }

  const isEnglish = window.__LANG__ === 'en';

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  const mobileMenuStyle = {
    // borderColor: '#6C8255',
    // borderStyle: 'solid',
    // borderWidth: '1px',
    borderRadius: '5px',
    // padding: '20px 0',
    height: '50px',
    width: '300px'
  }

  const filetedData = data.filter((item:any) => !isEnglish ? item['meta']['participation_en_only'] !== 'on' : true);

  return (
    <Box pt="9" pb="9" textAlign="center">
    {
      filetedData && !isMobile && (
        filetedData.map((item:any, index:number) => (
          <Button key={index} as="a" href={href(item['meta']['participation_slug'])} size="lg" fontSize="md" colorScheme={isActive(item['meta']['participation_slug']) ? 'dgr' : 'g'} variant={isActive(item['meta']['participation_slug']) ? 'solid' : 'outline'} ml="3" mr="3">
            {labelFilter(item.title)}
          </Button>
        ))
      )
    }
    {
      data && isMobile && (
        <>
        <Menu >
          <MenuButton as={Button} rightIcon={<ChevronDownIcon w={8} h={8} />} {...mobileMenuStyle}>
            {
              data.filter((item:any) => isActive(item['meta']['participation_slug']) ).map((item:any, index:number) => (
                <Heading size="2xl" key={index} noOfLines={1}>
                  {labelFilter(item.title)}
                </Heading>
              ))
            }
          </MenuButton>
          <MenuList width="300px" bgColor="#f9f9f9">
            {
              data.map((item:any, index:number) => (
                <MenuItem key={index} w="100%">
                  <Link as="a" w="100%" href={href(item['meta']['participation_slug'])} size="lg" fontSize="md" colorScheme={isActive(item['meta']['participation_slug']) ? 'dgr' : 'g'} variant={isActive(item['meta']['participation_slug']) ? 'solid' : 'outline'} ml="3" mr="3" pt="2" pb="2">
                    <Text fontSize="16">{labelFilter(item.title)}</Text>
                  </Link>
                </MenuItem>
              ))
            }
          </MenuList>
        </Menu>
        </>
      )
    }
    </Box>
  );
}

ParticipationSubMenu.defaultProps = {
};

export default ParticipationSubMenu;
